import(/* webpackMode: "eager" */ "/Users/panxo/Development/QC-AI/web/src/app/[locale]/not-found.tsx");
